<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                facilityForm: () => import('../forms/FacilityForm'),
                temperatureCheckFileForm: () => import('../forms/TemperatureCheckFileForm'),
                fields: [
                    { type: 'datetime', text: 'On', value: 'on', rules: [v => !!v || 'On is required'], isRequired: true },
                    { type: 'autocomplete', text: 'Facility', value: 'facilityId', rules: [v => !!v || 'Facility is required'], isRequired: true, form: () => import('./FacilityForm'), apiMethod: 'Facilities', claim: 'Facilities' },
                    { type: 'text', text: 'Area Name', value: 'areaName', rules: [v => !!v || 'Area Name is required', v => !(v && v.length > 100) || 'Area Name must be less than 100 characters'], isRequired: true, maxLength: 100 },
                    { type: 'number', text: 'Degrees Celsius', value: 'degreesCelsius', rules: [v => (v !== null && v !== '') || 'Degrees Celsius is required'], isRequired: true },
                    { type: 'files', text: 'Files', value: 'fileIds', parentColumnName: 'temperatureCheckId', form: () => import('../forms/TemperatureCheckFileForm') }
                ],
                apiMethod: 'TemperatureChecks',
                formTitle: 'Temperature Check',
            }
        },
    };
</script>
